export default "__VITE_PUBLIC_ASSET__ce293169__"